<template>
  <b-container fluid class="container-with-sidebar">
    <router-view/>
  </b-container>
</template>

<script>
import Header from '../components/Lti/Header/Header'
import Sidebar from '../components/Lti/Sidebar'
import jwtMixin from '../mixins/jwtMixin'

export default {
  name: 'Lti',
  components: {Header, Sidebar},
  mixins: [jwtMixin],
  data () {
    return {
      sidebarCollapsed: true
    }
  },
  created () {
    this.setCssVariables()
    window.addEventListener('resize', this._.debounce(this.setCssVariables, 300))
  },
  methods: {
    getDimensions () {
      return {
        width: 0.01 * window.innerWidth,
        height: 0.01 * window.innerHeight
      }
    },
    setCssVariables () {
      let dimensions = this.getDimensions()
      let width = dimensions.width
      let height = dimensions.height - 0.56
      document.documentElement.style.setProperty('--vw', width + 'px')
      document.documentElement.style.setProperty('--vh', height + 'px')
      if (this.jwtPrimaryColor() === undefined ||
        this.jwtPrimaryColor() === null ||
        this.jwtPrimaryColor() === 'undefined' ||
        this.jwtPrimaryColor() === 'null' ||
        this.jwtPrimaryColor() === '') {
        document.documentElement.style.setProperty('--lti-primary-color', '#AF2630')
      } else {
        document.documentElement.style.setProperty('--lti-primary-color', this.jwtPrimaryColor())
      }
      document.documentElement.style.setProperty('--lti-secondary-color', this.jwtSecondaryColor())
      document.documentElement.style.setProperty('--lti-font-family', this.jwtFont())
      document.documentElement.style.setProperty('--font-family-sans-serif', this.jwtFont())
      document.documentElement.style.setProperty('--font-family-monospace', this.jwtFont())
      document.body.style.setProperty('font-family', this.jwtFont())
    },
    onToggleCollapse (collapsed) {
      this.sidebarCollapsed = collapsed
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Lti.vue